module.exports = __webpack_public_path__ + "static/media/regulamento.9cc21c49.pdf";